module.exports = __webpack_public_path__ + "img/TL.8dfce0e0.png";